var exports = {
  "kL": "xfd349460--2652fe--container",
  "HU": "xfd349460--2652fe--aside",
  "VN": "xfd349460--2652fe--close",
};

module.exports = exports;
